
import './footer.scss';

export default function Footer() {
  return (
    <>
      <footer className="usps-footer">
        <div className="usps-footer__row">
          <div aria-label="Powered by United States Postal Service" className="usps-footer__powered-by">
            <a className="usps-footer__powered-by-brand-link" href="https://www.usps.com" target="_blank"><img aria-label="United States Postal Service" alt="USPS Logo" className="usps-footer__powered-by-brand" src="/wp-content/themes/uspsdelivers/media/powered-by.svg"/></a>
          </div>
          <div className="usps-footer__find-more">
            Find the products and services you need at <a className="usps-footer__find-more-link" href="https://www.usps.com" target="_blank">USPS.com</a>. 
          </div>
        </div>
        <div className="usps-footer__row">
          <nav className="usps-footer__menu">
            <ul className="usps-footer__menu-group">
              <li className="usps-footer__menu-item "><a className="usps-footer__menu-link" href="/../shipping/">Shipping</a></li>
              <li className="usps-footer__menu-item usps-footer__menu-item--break-after"><a className="usps-footer__menu-link" href="/../marketing/">Marketing</a></li>
              <li className="usps-footer__menu-item "><a className="usps-footer__menu-link" href="/../tools-and-resources/">Tools &amp; Resources</a></li>
              <li className="usps-footer__menu-item "><a className="usps-footer__menu-link" href="/../events/">Event Insights</a></li>
              <li className="usps-footer__menu-item "><a className="usps-footer__menu-link" aria-label="Learn more about USPS Delivers" href="/../about/">About Us</a></li>       
              </ul>
            <ul className="usps-footer__menu-group">
              <li className="usps-footer__menu-item "><a className="usps-footer__menu-link" href="/../site-index/">Site Index</a></li>
              <li className="usps-footer__menu-item usps-footer__menu-item--break-after"><a className="usps-footer__menu-link" target="_blank" href="https://about.usps.com/who/legal/foia/">FOIA</a></li>
              <li className="usps-footer__menu-item "><a className="usps-footer__menu-link" target="_blank" href="https://about.usps.com/who/legal/privacy-policy/">Privacy Policy</a></li>
              <li className="usps-footer__menu-item "><a className="usps-footer__menu-link" target="_blank" href="https://about.usps.com/who/legal/terms-of-use.htm">Terms of Use</a></li>        
              </ul>
          </nav>
        </div>

        <div className="usps-footer__row">
          <div className="usps-footer__disclaimer">
            <p><b>Reposting Our Content</b><br/>We encourage the reposting of our content, but not for profit. Spread the knowledge, but be sure to credit us when you do. Use this language when reposting: Reprinted with permission of USPSDelivers.com, an expert resource for future-thinking shippers and marketers. Please note: Photos and the USPS logo may not be altered or used apart from this site.</p>
            <p>&copy; 2023 U.S. Postal Service.  All rights reserved.</p>
          </div>
        </div>
      </footer>
    </>
  );
}
